<template>
  <div class="l-acount-tab">
    <ul>
      <li @click="goDiagList()" :class="{ 'is-current' : this.$route.name === 'diag-top' }">
        <a>監査結果</a>
      </li>
      <li v-if="(isIpo && isAdmin) || (!isIpo)" :class="{ 'is-current' : (this.$route.name === 'diag-section-list' || this.$route.name === 'diag-answer-input' || this.$route.name === 'option-diag-answer-input') }">
        <a @click="goDiagForm()">監査フォーム</a>
      </li>
      <li v-if="isAdmin" :class="{ 'is-current' : (this.$route.name === 'diag-management-list' || this.$route.name === 'diag-management-detail') }" >
        <a @click="goDiagManagementList(diagResultId)">監査の管理</a>
      </li>
      <li :class="{ 'is-current' : this.$route.name === 'task-list' || this.$route.name === 'task-detail' }">
        <a @click="goTaskList(diagResultId)">課題リスト</a>
      </li>  
    </ul>
  </div>
</template>

<script>

export default {
  computed: {
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    diagTitle() {
      return this.$store.getters['diag/getTitle'];
    },
    diagCourseName() {
      return this.$store.getters['diag/getDiagCourseName'];
    },
    diagCourseId() {
      return this.$store.getters['diag/getDiagCourseId'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    progress() {
      return Math.floor((this.answeredDiagResultItemsCountTotal / this.diagItemsCountTotal) * 100);
    },
    diagRevisionFlg() {
      return this.$store.getters['diag/getDiagRevisionFlg'];
    },
    sectionNotUseFlag() {
      return this.$store.getters['diag/getSectionNotUseFlag'];
    },
  },
  watch: {
    async corpId() {
      this.$router.push({ name: 'diag-top' });
    }
  },
  props: {
    isAdmin: {
      default: false
    },
    isIpo:{},
  },
  methods: {
    async goDiagList() {
      this.$store.dispatch('diag/setCorpId', this.corpId);
      if (this.diagResultId==null) {
        let diagResultId = await this.getLatestDiagResultId(this.corpId);
        if ( diagResultId > 0 ) {
          this.$router.replace({path: '/diag/'+this.corpId+'/'+diagResultId+'/topparam'});
        }else{
          const params = {};
          this.$router.push({ name: 'diag-top', params: params });
        }
      }else{
        this.$router.replace({path: '/diag/'+this.corpId+'/'+this.diagResultId+'/topparam'});
      }
//      this.$router.push({ name: 'diag-top' });
    },
    goDiagManagementList(diagResultId) {
      if (!diagResultId) return;
      this.$store.dispatch('diag/setDiagResultId', diagResultId);
      this.$router.push({ name: 'diag-management-list' });
    },
    goTaskList(diagResultId) {
      if (!diagResultId) return;
      this.$store.dispatch('diag/setDiagResultId', diagResultId);
      this.$router.push({ name: 'task-list' });
    },
    // 監査結果がないときに表示される監査フォーム遷移ボタンの処理
    // 条表示・非表示の設定で表示画面が異なるため、分岐している
    async goDiagForm() {
      if (!this.diagResultId) return;
      if (!this.sectionNotUseFlag) {
        this.$router.push({ name: 'diag-section-list', query: { diagCourseId: this.diagCourseId } });
      } else {
        this.$router.push({ name: 'option-diag-answer-input', query: { diagCourseId: this.diagCourseId } });
      }
    },
    async getLatestDiagResultId(corpId) {
      this.isRendering = true;
      this.isProcessing = true;

      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/getLatestDiagResultId', {
          corpId: corpId
        });
        if (res.status) {
          this.isRendering = false;
          this.isProcessing = false;
          return res.data.diagResultId;
        }else{
          this.isRendering = false;
          this.isProcessing = false;
        }
      }
    },
  }
}
</script>